import { bind } from 'ramda';

export const promiseAll = bind(Promise.all, Promise);
